import { render, staticRenderFns } from "./permission-list-wrapper.vue?vue&type=template&id=bc8bf300"
import script from "./permission-list-wrapper.vue?vue&type=script&lang=js"
export * from "./permission-list-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc8bf300')) {
      api.createRecord('bc8bf300', component.options)
    } else {
      api.reload('bc8bf300', component.options)
    }
    module.hot.accept("./permission-list-wrapper.vue?vue&type=template&id=bc8bf300", function () {
      api.rerender('bc8bf300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/security-group/user-binding/permission-list-wrapper.vue"
export default component.exports